import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'

export default function useAboutLinks({ nonReligiousMode, isNonEnCoreLanguage, isCoreLanguage }) {
  const { t } = useTranslation()

  return {
    id: 'about',
    title: t('nav.about-familysearch', 'About'),
    subNav: [
      {
        id: 'story',
        text: t('nav.links.about.story', 'Our Story'),
        url: i18n.language === 'zh' || i18n.language === 'zh-hans' ? '/zh/about/' : '/about/',
        linkName: 'ff_about_story',
        dataTestId: 'ff_our_story',
        isNew: false,
      },
      // {
      //   id: 'why',
      //   text: t('nav.links.about.why', 'Why FamilySearch'),
      //   url: '',
      //   linkName: 'ff_about_why',
      //   isNew: false,
      //   hidden: nonReligiousMode,
      // }, // needs url
      // {
      //   id: 'free',
      //   text: t('nav.links.about.free', `How it is Free`),
      //   url: '',
      //   linkName: 'ff_about_free',
      //   isNew: false,
      //   hidden: nonReligiousMode,
      // }, // needs url
      // {
      //   id: 'stories',
      //   text: t('nav.links.about.stories', 'Customer Stories'),
      //   url: '',
      //   linkName: 'ff_about_stories',
      //   isNew: false,
      //   hidden: nonReligiousMode,
      // }, // needs url
      {
        id: 'privacy',
        text: t('nav.links.about.privacy', 'Data Privacy'),
        url: '/legal/privacy',
        linkName: 'ff_about_privacy',
        dataTestId: 'ff_data_privacy',
        isNew: false,
      },
      {
        id: 'newsroom',
        text: t('nav.links.about.newsroom', 'Newsroom'),
        url: `https://www.familysearch.org/${i18n.language}/newsroom/`,
        linkName: 'ff_about_newsroom',
        dataTestId: 'ff_newsroom',
        isNew: false,
        hidden: isNonEnCoreLanguage || !isCoreLanguage || nonReligiousMode,
      },
    ],
  }
}
